import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { StepUpAuthService } from '../services/step-up-auth.service';
import { globalMessages } from '../global-message';

/**
 * HTTP interceptor that handles expired token responses.
 *
 * When the backend returns a 401 Unauthorized (token expired or invalid),
 * this interceptor:
 * 1. Clears all local auth state (tokens + auth level from sessionStorage).
 * 2. Redirects the user to the sign-in page.
 *
 * This ensures users don't stay on protected pages with stale tokens
 * when the server rejects their requests.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const stepUpAuth = inject(StepUpAuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Skip redirect for login/auth endpoints — those handle their own 401s
        const isAuthEndpoint =
          req.url.includes('/auth/login') || req.url.includes('/auth/otp/verify');

        if (!isAuthEndpoint) {
          stepUpAuth.clearAuth();
          router.navigate([globalMessages.routeSignIn]);
        }
      }

      return throwError(() => error);
    })
  );
};
